import React from 'react';
import Serializer, {
  type SerializeArguments,
  type DeserializeArguments,
} from './Serializer';
import { type DividerLineElement } from '../../types/aha-editor';
import { isDividerLineElement } from '../../types/guards';
import { isHTMLElementNode } from '../helpers/serializerHelpers';

class SerializerDividerLine extends Serializer {
  static serialize({ node }: SerializeArguments): React.ReactNode {
    if (!isDividerLineElement(node)) return;

    return <hr />;
  }

  static deserialize({
    el,
  }: DeserializeArguments): DividerLineElement | undefined {
    if (!isHTMLElementNode(el) || el.tagName.toLowerCase() !== 'hr') return;

    return {
      type: 'divider-line',
      children: [
        {
          text: '',
        },
      ],
    };
  }
}
export default SerializerDividerLine;
